import React from "react";

import style from "./index.module.scss";

export const PressHero = (props: { title: string }) => (
    <div className={style.container}>
        <h1 className={style.header}>{props.title}</h1>
    </div>
);
